// Temporary text-based logo using app initials, styled as a rounded badge.
// Swap this out later for a real logo image once one is ready —
// same component used in the driver app, kept consistent across both apps.
function Logo({ size = 40, variant = 'white-bg' }) {
  const isBlueBg = variant === 'blue-bg';

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: isBlueBg ? 'white' : '#2563eb',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <span
        style={{
          color: isBlueBg ? '#2563eb' : 'white',
          fontWeight: 800,
          fontSize: size * 0.36,
          letterSpacing: -0.5,
        }}
      >
        HTH
      </span>
    </div>
  );
}

export default Logo;
